import * as larvitar from "larvitar/dist/larvitar";

const adjustHandleToSquare = (anchor, handle) => {
  const dx = handle.x - anchor.x;
  const dy = handle.y - anchor.y;
  if (dx === 0 && dy === 0) {
    return false;
  }

  // Use the dominant axis delta so the ROI stays square while dragging.
  const size = Math.max(Math.abs(dx), Math.abs(dy));
  const signX = dx === 0 ? (dy < 0 ? -1 : 1) : Math.sign(dx);
  const signY = dy === 0 ? (dx < 0 ? -1 : 1) : Math.sign(dy);
  const nextX = anchor.x + signX * size;
  const nextY = anchor.y + signY * size;

  if (handle.x === nextX && handle.y === nextY) {
    return false;
  }

  handle.x = nextX;
  handle.y = nextY;
  return true;
};

class SquareRoiTool extends larvitar.cornerstoneTools.RectangleRoiTool {
  constructor(props = {}) {
    super(props);
    this.name = "SquareRoi";
  }

  renderToolData(evt) {
    const toolData = larvitar.cornerstoneTools.getToolState(
      evt.currentTarget,
      this.name
    );

    if (toolData) {
      toolData.data.forEach(data => {
        const { handles } = data || {};
        if (!handles || !handles.start || !handles.end) {
          return;
        }

        const movingStart = handles.start.moving;
        const movingEnd = handles.end.moving;
        const handle = movingEnd || !movingStart ? handles.end : handles.start;
        const anchor = handle === handles.end ? handles.start : handles.end;

        if (adjustHandleToSquare(anchor, handle)) {
          data.invalidated = true;
        }
      });
    }

    super.renderToolData(evt);
  }
}

export default SquareRoiTool;
